module.exports = __webpack_public_path__ + "static/media/荷载.2b6b5e4c.svg";